<template>
    <div class="checkpoints">
        <composable-checkpoint v-for="checkpoint in checkpoints"
            :checkpoint-name="checkpoint.name"
            @dragstart.native="dragStart($event, checkpoint)"
        />
    </div>
</template>

<script>
import ToolboxDragAction from "./toolbox-drag-action";
import { checkpointDefinitionsArray } from "@modules/JourneyBuilder/Bricks/checkpoint-definitions";

import {ComposableCheckpoint} from "./Checkpoints";
import { optionsCheckpoint } from '@modules/JourneyBuilder/Bricks/checkpoint-definitions';

export default {
    name: "menu-checkpoint-toolbox",
    components: {
        ComposableCheckpoint
    },
    data(){
        return {
            checkpoints: checkpointDefinitionsArray.filter(x => x.name != optionsCheckpoint.name)
        }
    },
    methods: {
        dragStart(event, checkpoint){
            const { x, y, width, height } = event.target.getBoundingClientRect();

            const action = new ToolboxDragAction(ToolboxDragAction.TYPE_CHECKPOINT, {
                name: checkpoint.name,
                elementWidth: width,
                elementHeight: height,

                //Take into account mouse position within the element on drag start
                offsetX: x - event.clientX,
                offsetY: y - event.clientY
            });

            event.dataTransfer.dropEffect = 'none';
            action.writeToEvent(event);
        }
    }
}
</script>

<style lang="scss" scoped>
.checkpoints {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
</style>